module.exports = __webpack_public_path__ + "img/5.5952004d.jpg";